import { useEffect, useState } from "react";
import { Download, FileText, LockSimple } from "@phosphor-icons/react";
import api, { apiError } from "../../lib/api";
import { downloadDoc } from "../../lib/download";
import { fmtDate } from "../../lib/format";
import AppLayout, { PageLoader, EmptyState } from "../../components/AppLayout";
import { Badge } from "../../components/ui/badge";

const CATEGORIES = ["KYC Documents", "Agreements", "Statements", "Transaction Documents",
  "Bank Proof", "Financial Statement", "Other Documents"];

export default function DocumentsPage() {
  const [docs, setDocs] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/investor/documents").then((r) => setDocs(r.data)).catch((e) => setError(apiError(e)));
  }, []);

  if (error) return <AppLayout title="Documents"><p className="text-red-400 text-sm">{error}</p></AppLayout>;
  if (!docs) return <AppLayout title="Documents"><PageLoader /></AppLayout>;

  return (
    <AppLayout title="Documents" subtitle="Secure access to your KYC records, agreements and statements.">
      <div className="fade-up space-y-5">
        <div className="flex items-center gap-2 text-[11px] text-zinc-500">
          <LockSimple size={13} className="text-emerald-500/70" />
          Documents are served through authorized, encrypted channels only.
        </div>
        {docs.length === 0 && <EmptyState message="No documents available yet." />}
        {CATEGORIES.map((cat) => {
          const items = docs.filter((d) => d.category === cat);
          if (items.length === 0) return null;
          return (
            <div key={cat} className="glass-card overflow-hidden">
              <div className="px-6 pt-5 pb-3">
                <h3 className="font-heading font-semibold text-white">{cat}</h3>
              </div>
              {items.map((d) => (
                <div key={d.id} data-testid={`doc-row-${d.id}`}
                  className="px-6 py-3.5 border-t border-white/[0.04] flex items-center gap-4 hover:bg-white/[0.02] transition-colors duration-150">
                  <div className="h-9 w-9 rounded-lg bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 flex items-center justify-center shrink-0">
                    <FileText size={17} weight="duotone" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm font-medium text-white truncate">{d.name}</p>
                    <p className="text-[11px] text-zinc-500">
                      Uploaded {fmtDate(d.uploaded_at)} · {d.size_kb} KB · by {d.uploaded_by}
                    </p>
                  </div>
                  <Badge variant="outline" className="hidden sm:inline-flex text-[10px] border-white/10 text-zinc-400">
                    {d.type || (d.content_type === "application/pdf" ? "PDF" : "FILE")}
                  </Badge>
                  <button onClick={() => downloadDoc(d)} data-testid={`doc-download-${d.id}`}
                    className="h-9 w-9 rounded-lg border border-white/10 flex items-center justify-center text-zinc-400 hover:text-emerald-300 hover:border-emerald-500/30 transition-colors duration-200">
                    <Download size={16} />
                  </button>
                </div>
              ))}
            </div>
          );
        })}
      </div>
    </AppLayout>
  );
}
